import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { OrdersService } from '../../../services';
import { fromStorage, Globals } from '../../../utils';
import { UploadFileIcon, XLSIcon } from '../../../assets/icons';

const ModalBulkCreateOrder = ({ onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onDownload = () => {
    const link = document.createElement('a');
    link.href = fromStorage('/cartelera_subida_masiva.xlsx');
    link.target = '_blank';
    link.download = 'cartelera_subida_masiva.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  const onUpload = (e) => {
    if (!e.target.files.length) return;

    const data = {
      file: e.target.files[0],
      hasFile: true,
    };

    e.target.value = "";

    Globals.confirm('¿Realmente desea subir el archivo?', async () => {
      setIsLoading(true);
      try {
        await OrdersService.moderator.import(data);
        toast.success('Archivo importado con éxito');
        onSuccess();
        onClose();

      } catch (error) {
        console.log(error)
      }

      setIsLoading(false);
    });
  }

  return (
    <div className="px-4 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] w-[40rem] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-2xl font-bold text-black">Carga masiva de viajes</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
          disabled={isLoading}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="space-y-2">
        <p>
          <b>Paso 1-</b> Descarga el archivo de excel
          <div>
            <button className="bg-green rounded-lg flex items-center p-2 text-white gap-2" onClick={onDownload}>
              <img src={XLSIcon} className="w-6 h-6 invert" alt="Descargar excel" />
              <span>Descargar Archivo Excel</span>
            </button>
          </div>
        </p>
        <p><b>Paso 2-</b> Carga la información de los viajes, en el orden indicado en el excel</p>
        <p>
          <b>Paso 3-</b> Sube tu archivo excel con la información de los viajes
          <label className="bg-green rounded-lg flex items-center p-2 text-white gap-2 max-w-max cursor-pointer" htmlFor="excel-file">
            <img src={UploadFileIcon} className="w-6 h-6" alt="Descargar excel" />
            <span>Subir Formato de Viajes</span>
          </label>
        </p>
      </div>

      <input
        id="excel-file"
        type="file"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={onUpload}
        hidden
      />

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
          disabled={isLoading}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ModalBulkCreateOrder;
